import { computed, Injectable } from '@angular/core';
import { getBrandLabel } from '@environments/model';
import { StoreBase } from '@stores/abstract';
import { App } from '@stores/models';

@Injectable({ providedIn: 'root' })
export class AppStore extends StoreBase<App> {
  override storeName = 'AppStore';
  readonly brandId = this.select('branding');
  readonly brandLabel = computed(() => {
    const brandId = this.brandId();
    return brandId ? getBrandLabel(brandId) : '';
  });
}
